import React from 'react';
import { Box, Tabs, Tab, Chip } from '@mui/material';
import { Assessment as AnalyticsIcon } from '@mui/icons-material';
import { colors } from '../../../theme/designTokens';
import { TAB_CONFIGS } from './constants';

interface AIStylesTabBarProps {
  tabValue: number;
  onChange: (newValue: number) => void;
  counts: number[];
  unsavedCategories: Set<string>;
}

const AIStylesTabBar: React.FC<AIStylesTabBarProps> = ({
  tabValue,
  onChange,
  counts,
  unsavedCategories,
}) => {
  return (
    <Box
      sx={{
        bgcolor: colors.deepTeal[500],
        borderTop: '1px solid rgba(255,255,255,0.08)',
        px: 1,
      }}
    >
      <Tabs
        value={tabValue}
        onChange={(_, newValue) => onChange(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        TabIndicatorProps={{
          style: {
            backgroundColor: colors.warmGold[500],
            height: 3,
          },
        }}
        sx={{
          minHeight: 44,
          '& .MuiTab-root': {
            fontFamily: '"Montserrat", sans-serif',
            fontWeight: 600,
            fontSize: '0.78rem',
            letterSpacing: '0.03em',
            textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.45)',
            minHeight: 44,
            py: 1,
            px: 2,
            '&.Mui-selected': {
              color: '#fff',
            },
          },
        }}
      >
        {TAB_CONFIGS.map((config, index) => (
          <Tab
            key={config.categoryKey}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                {config.label}
                <Chip
                  size="small"
                  label={counts[index] || 0}
                  sx={{
                    height: 18,
                    minWidth: 24,
                    fontFamily: '"Montserrat", sans-serif',
                    fontWeight: 700,
                    fontSize: '0.65rem',
                    bgcolor: tabValue === index ? colors.warmGold[500] : 'rgba(255,255,255,0.12)',
                    color: '#fff',
                    '& .MuiChip-label': { px: 0.6 },
                  }}
                />
                {unsavedCategories.has(config.categoryKey) && (
                  <Box
                    sx={{
                      width: 6,
                      height: 6,
                      borderRadius: '50%',
                      bgcolor: colors.warmGold[500],
                      animation: 'pulse 1.5s ease-in-out infinite',
                      '@keyframes pulse': {
                        '0%, 100%': { opacity: 1, transform: 'scale(1)' },
                        '50%': { opacity: 0.5, transform: 'scale(1.3)' },
                      },
                    }}
                  />
                )}
              </Box>
            }
          />
        ))}
        <Tab
          icon={<AnalyticsIcon sx={{ fontSize: 18 }} />}
          label="Analytics"
          iconPosition="start"
        />
      </Tabs>
    </Box>
  );
};

export default AIStylesTabBar;
